import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  constructor(
    @Inject(DOCUMENT) private dom: Document,
  ) { }

  private scrollIntoViewOptions: ScrollIntoViewOptions = {
    behavior: 'smooth',
    block: 'start',
    inline: 'nearest',
  };

  scrollToElement($el: Element): void {
    $el.scrollIntoView(this.scrollIntoViewOptions);
  }

  scrollToElementById(elementId: string) {
    setTimeout(() => {
      try {
        const $el = this.dom.getElementById(elementId);
        $el.scrollIntoView(this.scrollIntoViewOptions);
      }
      catch (err) {

      }
    }, 0);
  }
}
